import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { BehaviorSubject } from 'rxjs';

import { Tenant } from 'src/models';
import { TenantsService } from 'src/services/tenants.service';

import { SharedTenantService } from '../super-admin-taxonomy/shared-tenant.service';

@Component({
  selector: 'app-super-admin-knowledge-gaps-tenant-selection',
  templateUrl: './super-admin-knowledge-gaps-tenant-selection.component.html',
  styleUrls: ['./super-admin-knowledge-gaps-tenant-selection.component.scss'],
})
export class SuperAdminKnowledgeGapsTenantSelectionComponent implements OnInit {
  isLoadingTenants = true;

  // Tenant selection
  public readonly tenants$: BehaviorSubject<Partial<Tenant>[]> = new BehaviorSubject([]);
  public tenantSearchText: string = '';
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;
  public selected = [];
  public tenantColumns = [
    { name: 'Name', prop: 'name', flexGrow: 2 },
    { name: 'ID', prop: 'id', flexGrow: 1 },
    { name: 'Subdomain', prop: 'subdomain', flexGrow: 1 },
  ];

  constructor(
    private router: Router,
    private tenantsService: TenantsService,
    private sharedTenantService: SharedTenantService,
  ) {}

  async ngOnInit() {
    await this.loadTenants();
  }

  async loadTenants() {
    const res = await this.tenantsService.list({
      limit: null,
    });
    this.tenants$.next(res.data);
    this.isLoadingTenants = false;
  }

  onTenantSelect(event) {
    if (event.selected.length > 0) {
      const tenant = event.selected[0];
      this.selectTenant(tenant);
    }
  }

  selectTenant(tenant: Partial<Tenant>) {
    // Update shared tenant service for other components
    this.sharedTenantService.setSelectedTenant(tenant);

    // Navigate to tenant insights component
    this.router.navigate(['/super-admin/knowledge-gaps', tenant.id]);
  }
}
